import { render, staticRenderFns } from "./ProductSelectSection.vue?vue&type=template&id=d7f8c956&scoped=true&"
import script from "./ProductSelectSection.vue?vue&type=script&lang=ts&"
export * from "./ProductSelectSection.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSelectSection.vue?vue&type=style&index=0&id=d7f8c956&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f8c956",
  null
  
)

export default component.exports